import config from '../config/index'
/**
 * 获取地址
 * @returns {string}
 */
export const getBaseUrl = () => {
  let baseUrl = ''
  switch (process.env.NODE_ENV) {
    case 'development':
      // 这里是本地的请求url
      baseUrl = config.apiUrl.dev
      break
    case 'production':
      // 生产环境url
      baseUrl = config.apiUrl.pro
      break
    default:
      baseUrl = config.apiUrl.dev
      break
  }
  return baseUrl
}
/* export const getDownloadBaseUrl = () => {
  let baseUrl = ''
  switch (process.env.NODE_ENV) {
    case 'development':
      // 这里是本地的请求url
      baseUrl = config.apiUrl.dev_downlodUrl
      break
    case 'production':
      // 生产环境url
      baseUrl = config.apiUrl.pro_downloadUrl
      break
    default:
      baseUrl = config.apiUrl.dev_downlodUrl
      break
  }
  return baseUrl
} */
/**
 * 过滤对象中为空的属性
 * @param obj
 * @returns {*}
 */
export const filterObj = (obj) => {
  if (!(typeof obj === 'object')) {
    return
  }
  const object = {...obj}
  for (let key in object) {
    if (object.hasOwnProperty(key) &&
            (object[key] == null || object[key] === undefined || object[key] === '')) {
      delete object[key]
    }
  }
  return object
}

/**
 * 时间格式化
 * @param value
 * @param fmt
 * @returns {*}
 */
export const formatDate = (value, fmt) => {
  let regPos = /^\d+(\.\d+)?$/
  if (regPos.test(value)) {
    // 如果是数字
    let getDate = new Date(value)
    let o = {
      'M+': getDate.getMonth() + 1,
      'd+': getDate.getDate(),
      'h+': getDate.getHours(),
      'm+': getDate.getMinutes(),
      's+': getDate.getSeconds(),
      'q+': Math.floor((getDate.getMonth() + 3) / 3),
      'S': getDate.getMilliseconds()
    }
    if (/(y+)/.test(fmt)) {
      fmt = fmt.replace(RegExp.$1, (getDate.getFullYear() + '').substr(4 - RegExp.$1.length))
    }
    for (let k in o) {
      if (new RegExp('(' + k + ')').test(fmt)) {
        fmt = fmt.replace(RegExp.$1, (RegExp.$1.length === 1) ? (o[k]) : (('00' + o[k]).substr(('' + o[k]).length)))
      }
    }
    return fmt
  } else {
    // TODO
    value = value.trim()
    return value.substr(0, fmt.length)
  }
}
/**
 * 触发 window.resize
 */
export const triggerWindowResizeEvent = () => {
  let event = document.createEvent('HTMLEvents')
  event.initEvent('resize', true, true)
  event.eventType = 'message'
  window.dispatchEvent(event)
}

export const getToken = () => {
  const token = localStorage.getItem('TOKEN_KEY')
  if (token && token !== 'undefined') {
    return token
  } else {
    return false
  }
}
export const getRealName = () => {
  const realName = localStorage.getItem('REAL_NAME')
  if (realName && realName !== 'undefined') {
    return realName
  } else {
    return ''
  }
}

export const getUserInfo = () => {
  const userInfo = localStorage.getItem('USER_INFO')
  return JSON.parse(userInfo)
}

/**
 * 数组对象去重
 * @param array
 * @returns {string}
 */
export const arrayUnique = (array, key) => {
  if (key) {
    const res = new Map()
    return array.filter((array) => !res.has(array[key]) && res.set(array[key], 1))
  } else {
    const arr = new Set()
    array.map(item => {
      arr.add(item)
    })
    return arr
  }
}



// WEBPACK FOOTER //
// ./src/utils/util.js